import React, { useState } from "react";
import { postData } from "../common/utils";
import { useHistory } from "react-router";
import "./popupplug.css";

import "./comments.css";
//Images

import like_blue2 from "../../assets/images/like_blue2.png";
import like_grey from "../../assets/images/like.png";

import { useAlert } from "react-alert";



const LikeComment = (props) => {
  //console.log("propppps-------------------comment------------",props);
  const history = useHistory();

  const [commentLike, setCommentLike] = useState(props.data.comm_user_like);
  const [commentLikesQuantity, setCommentLikesQuantity] = useState(props.data.CommentLikesQuantity);
  const [allCommentLikes, setAllCommentLikes] = useState(props.data.comm_likes);
  const alert = useAlert();
  const [userLike, setUserLike] = useState(false);


  function toggleCommentLike() {

    //console.log("Comment toggle like");
    var likeFlag = !commentLike;
    postData(process.env.REACT_APP_API_URL + "api/posts/likecomment", {
      postID: props.postID,
      likeFlag: likeFlag,
      postCommentID: props.data.postCommentID
    }).then((data) => {
      //console.log(data,"DATA")
      if (data.issuccessful == true) {
        setCommentLike(!commentLike);
        if (likeFlag) {
          setCommentLikesQuantity(commentLikesQuantity + 1);
        } else {
          setCommentLikesQuantity(commentLikesQuantity - 1);
        }
        setAllCommentLikes(data.likes);
        setUserLike(data.user_like);
        //console.log("ALL_LIKES",data.user_like);
        // setTimeout(()=>{
        //   window.location.reload(false);
        // },1000);
      } else {
        //console.log(data.message);
      }
    });
  }

  //#region likes

  const ComLikesComp = () => {
    if (commentLikesQuantity == 0) {
      return <div></div>;
    } else {
      if (commentLikesQuantity < 3) {
        return (
          <div className="">
            {commentLikesQuantity}
          </div>
        );
      }
      else {
        var likeUserName = [];
        //console.log(count,"COUnt",allCommentLikes,"ALL_likes");
        for (var i = 0; i < allCommentLikes.length; i++) {
          if (i < 2) {
            likeUserName.push(allCommentLikes[i].userName);
          } else {
            break;
          }
        }
        // props.data.likes.map((like,index) => {
        //   if(index<=1){
        //   return like.userName;
        //   }
        //   else{
        //     break;
        //   }
        // });
        return (
          <div className="">

            {commentLikesQuantity}

          </div>
        );
      }
    }
  };
  //#endregion

  //#region comment component

  //#endregion

  //#region popup
  const ControlledPopup = (props) => {
    const [open, setOpen] = useState(false);
    //const closeModal = () => setOpen(false);
    return (


      <ComLikesComp />


    );
  };
  //#endregion

  // const Likefun = () =>{
  //   if(like){
  //     console.log("Blue");
  //   }else{
  //     console.log("Grey")
  //   }
  // }

  var uid = props.data.UserID;
  return (
    <div className="pp-likes-wrap pp-padd" style={{ position: "relative" }}>
      <div className="pp-controls" style={{ color: "#98a5ad", marginTop: "-8px", width: "max-content", marginLeft: "50px" }}>
        {userLike == "true" && <>

          <div className="pp-like" onClick={toggleCommentLike} style={{ color: "#98a5ad", marginLeft: "0", display: "flex", border: "1px solid #98a5ad", marginRight: "10px", borderRadius: "20px", padding: "0 10px" }} >

            <img style={{ width: "15px", height: "15px", margin: "auto", marginRight: "8px" }} src={commentLike ? like_blue2 : like_grey} alt="" />
            <ControlledPopup data={allCommentLikes} />

            {/* <span>Like</span> */}
          </div> &middot;&nbsp;&nbsp;You liked</>}

        {commentLike && <>

          <div className="pp-like" onClick={toggleCommentLike} style={{ color: "#98a5ad", marginLeft: "0", display: "flex", border: "1px solid #98a5ad", marginRight: "10px", borderRadius: "20px", padding: "0 10px" }} >

            <img style={{ width: "15px", height: "15px", margin: "auto", marginRight: "8px" }} src={commentLike ? like_blue2 : like_grey} alt="" />
            <ControlledPopup data={allCommentLikes} />


            {/* <span>Like</span> */}
          </div> &middot;&nbsp;&nbsp;You liked</>}

        {!commentLike && commentLikesQuantity >= 1 && <>

          <div className="pp-like" onClick={toggleCommentLike} style={{ color: "#98a5ad", marginLeft: "0", display: "flex", border: "1px solid #98a5ad", marginRight: "10px", borderRadius: "20px", padding: "0 10px" }}>

            <img style={{ width: "15px", height: "15px", margin: "auto", marginRight: "8px" }} src={commentLike ? like_blue2 : like_grey} alt="" />
            <ControlledPopup data={allCommentLikes} />
            {/* <span>Like</span> */}
          </div>&middot;&nbsp;&nbsp;Like</>}

        {commentLikesQuantity == 0 && <>

          <div className="pp-like" onClick={toggleCommentLike} style={{ color: "#98a5ad", marginLeft: "0", display: "flex", margin: "0" }}>

            <img style={{ width: "15px", height: "15px", margin: "auto", marginRight: "8px" }} src={commentLike ? like_blue2 : like_grey} alt="" />
            <ControlledPopup data={allCommentLikes} />
            {/* <span>Like</span> */}
          </div>&middot;&nbsp;&nbsp;Like</>}
      </div>

      {/* <div className="pp-likes-flex" style={{marginLeft:"70px",marginTop:"-45px"}}>
           ,border:"1px solid #98a5ad",marginRight:"10px", borderRadius:"20px",padding:"0 10px"
            
          </div> */}
    </div>

  );
};

export default LikeComment;
